import { SignatureScopeFilter } from '../enums/signature-scope.const';
import { SignatureStatus } from '../enums/signature-status.const';
import { useSignatures } from './use-signatures.hook';

const PENDING_USER_SIGNATURE_STATUSES: SignatureStatus[] = [
  SignatureStatus.SIGNATURE_PENDING,
  SignatureStatus.PARTIALLY_SIGNED,
];

export const usePendingSignaturesCount = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { count } = useSignatures({
    currentPage: 1,
    enabled,
    mySignatorySigned: false,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    scope: SignatureScopeFilter.MY_SIGNATURES,
    statuses: PENDING_USER_SIGNATURE_STATUSES,
    take: 1,
  });

  return count;
};
